"use client";

import React from "react";
import Link from "next/link";

export const Logo = () => {
  return (
    <Link href="/" className="flex items-center">
      <span className="text-xl font-bold text-white tracking-[-0.5px]">
        Probabl
      </span>
    </Link>
  );
};
